var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgStorageBoxIcon = function SvgStorageBoxIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#EAB308",
    fillRule: "evenodd",
    d: "m30.222 2.89 5 6.666a1.7 1.7 0 0 1 .315.751q.02.135.019.27v21.09a6.116 6.116 0 0 1-6.112 6.111H10.556a6.116 6.116 0 0 1-6.112-6.11V10.846a1.6 1.6 0 0 1 .278-1.298l5.056-6.66c.315-.42.809-.666 1.333-.666H28.89c.524 0 1.018.249 1.333.666m-20.778 6 2.5-3.334h6.39v3.333zm12.223 0V5.555h6.388l2.5 3.333zm-.49 21.177 5-5h.005a1.667 1.667 0 1 0-2.358-2.358l-2.155 2.156v-7.087a1.667 1.667 0 0 0-3.333 0v7.087l-2.156-2.156a1.667 1.667 0 1 0-2.358 2.358l5 5a1.663 1.663 0 0 0 2.356 0",
    clipRule: "evenodd"
  })));
};
export default SvgStorageBoxIcon;